import React, { useState } from 'react';
import CharCounter from '../components/CharCounter';

function UserAddEntryForm({ value, onChange, onAddEntry }) {
  const [isFocused, setIsFocused] = useState(false);
  const NOTES_MAX = 2000;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    onAddEntry();
    setIsFocused(false);
  };

  const handleDiscard = () => {
    onChange(''); // ✅ Clear the input
    setIsFocused(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSubmit(e);
    if (e.key === 'Escape') handleDiscard();
  };

  return (
    <div className="add-entry-container">
      <form className="add-entry-input-wrapper" onSubmit={handleSubmit}>
        <input
          type="text"
          className="add-entry-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onKeyDown={handleKeyDown}
          maxLength={NOTES_MAX}
          placeholder="Write a note or track progress..."
        />

        <CharCounter current={value.length} max={NOTES_MAX} />
      </form>

      {/* ✅ Only show Save/Discard when user is typing */}
      {(isFocused || value.trim().length > 0) && (
        <div
          className="entry-action-btns"
          style={{
            display: 'flex',
            gap: '8px',
            marginTop: '8px',
            justifyContent: 'flex-end',
          }}
        >
          <button
            type="button"
            className="discard-entry-btn"
            onClick={handleDiscard}
            style={{
              padding: '6px 14px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: '0.85rem',
              color: '#888',
            }}
          >
            Discard
          </button>
          <button
            type="button"
            className="save-entry-btn"
            onClick={handleSubmit}
            disabled={!value.trim()}
            style={{
              padding: '6px 14px',
              borderRadius: '6px',
              border: 'none',
              background: value.trim() ? '#10b981' : '#ccc',
              color: 'white',
              cursor: value.trim() ? 'pointer' : 'not-allowed',
              fontSize: '0.85rem',
              fontWeight: '600',
            }}
          >
            Save Note
          </button>
        </div>
      )}
    </div>
  );
}

export default UserAddEntryForm;
